import axios from 'axios';

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use((config) => {
  config.headers['X-Is-Admin'] = 'true';
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || `Something went wrong: ${error}`)
);

export default axiosInstance;
